<template>
  <div>
    <!-- 日历票授权弹框开始 -->

    <el-dialog
      title="日历票授权"  :close-on-click-modal="false"
      :visible.sync="defailDialogVisible"
      :before-close="defailHandleClose"
      width="95%"
      center
    >
      <el-divider></el-divider>
      <div class="title_flex">
        <div class="athorTitle">
          <el-button  @click="fun_date(-7,dateWeek.monday)">上一周</el-button>
          <el-button @click="fun_date(7,dateWeek.monday)">下一周</el-button>
        </div>
        <div class="input_btns">
            <span style="color:red;font-size:1.4rem;">注意：暂无授权数量是指库存已被授权给其他分销商(数量输入 “ -1 ” 为无限制)</span>
            <el-input v-model="data.name" placeholder="请输入产品名称"></el-input>
            <el-button @click="listBtns">查询</el-button>
        </div>
      </div>
      <div class="authorTable">
        <el-table
          ref="multipleTable"
          :data="tableData"
          element-loading-text="数据加载中"
          v-loading="loading"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="商品名称" >
            <template slot-scope="scope">{{ scope.row.ProductName }}</template>
          </el-table-column>
          <el-table-column :label="dateWeek.monday" width="180">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.monday.substring(0,10)">
                  <div v-if="item.status=='1'">
                    <div>
                    <div class="disFlex"> 数量：<el-input
                        :value="formatDaynumber(item)"
                        @input="onDaynumberInput($event, item)"
                        @blur="NumberF(item, scope.row.impowerState)"
                        :readonly="scope.row.impowerState != 1"></el-input>
                    </div>
                      <div class="disFlex agent"> 代理价：
                        <input type="number" v-model="item.agentprice" @blur="NumberP(item)">
                      </div>
                    </div>
                  </div>
                  <div v-if="item.status=='2'">
                    停售
                  </div>
                  <div v-if="item.status=='3'">
                    暂无授权数量
                  </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="dateWeek.tuesday"  width="180">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.tuesday.substring(0,10)">
                <div v-if="item.status=='1'">
                  <div class="disFlex"> 数量：<el-input
                      :value="formatDaynumber(item)"
                      @input="onDaynumberInput($event, item)"
                      @blur="NumberF(item, scope.row.impowerState)"
                      :readonly="scope.row.impowerState != 1"></el-input>
                  </div>
                  <div class="disFlex agent"> 代理价：
                    <input type="number" v-model="item.agentprice" @blur="NumberP(item)">
                    <!-- <el-input v-model="item.agentprice" @blur="NumberF(item)">
                    </el-input> -->
                  </div>
                </div>
                <div v-if="item.status=='2'">
                  停售
                </div>
                <div v-if="item.status=='3'">
                  暂无授权数量
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="dateWeek.wednesday"  width="180">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.wednesday.substring(0,10)">
                <div v-if="item.status=='1'">
                  <div class="disFlex"> 数量：<el-input
                      :value="formatDaynumber(item)"
                      @input="onDaynumberInput($event, item)"
                      @blur="NumberF(item, scope.row.impowerState)"
                      :readonly="scope.row.impowerState != 1"></el-input>
                  </div>
                  <div class="disFlex agent"> 代理价：
                    <input type="number" v-model="item.agentprice" @blur="NumberP(item)">
                    <!-- <el-input v-model="item.agentprice" @blur="NumberF(item)"></el-input> -->
                  </div>
                </div>
                <div v-if="item.status=='2'">
                  停售
                </div>
                <div v-if="item.status=='3'">
                  暂无授权数量
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="dateWeek.thursday"  width="180">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.thursday.substring(0,10)">
               
                <div  v-if="item.status=='1'">
                  <div class="disFlex"> 数量：<el-input
                      :value="formatDaynumber(item)"
                      @input="onDaynumberInput($event, item)"
                      @blur="NumberF(item, scope.row.impowerState)"
                      :readonly="scope.row.impowerState != 1"></el-input>
                  </div>
                  <div class="disFlex agent"> 代理价：
                    <input type="number" v-model="item.agentprice" @blur="NumberP(item)">
                    <!-- <el-input v-model="item.agentprice" @blur="NumberF(item)"></el-input> -->
                  </div>
                </div>
                <div v-if="item.status=='2'">
                  停售
                </div>
                <div v-if="item.status=='3'">
                  暂无授权数量
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="dateWeek.friday"  width="180">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.friday.substring(0,10)">
                <div v-if="item.status=='1'">
                  <div class="disFlex"> 数量：<el-input
                      :value="formatDaynumber(item)"
                      @input="onDaynumberInput($event, item)"
                      @blur="NumberF(item, scope.row.impowerState)"
                      :readonly="scope.row.impowerState != 1"></el-input>
                  </div>
                  <div class="disFlex agent"> 代理价：
                    <input type="number" v-model="item.agentprice" @blur="NumberP(item)">
                    <!-- <el-input v-model="item.agentprice" @blur="NumberF(item)"></el-input> -->
                  </div>
                </div>
                <div v-if="item.status=='2'">
                  停售
                </div>
                <div v-if="item.status=='3'">
                  暂无授权数量
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="dateWeek.staturday"  width="180">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.staturday.substring(0,10)">
                <div v-if="item.status=='1'">
                  <div class="disFlex"> 数量：<el-input
                      :value="formatDaynumber(item)"
                      @input="onDaynumberInput($event, item)"
                      @blur="NumberF(item, scope.row.impowerState)"
                      :readonly="scope.row.impowerState != 1"></el-input>
                  </div>
                  <div class="disFlex agent"> 代理价：
                    <input type="number" v-model="item.agentprice" @blur="NumberP(item)">
                    <!-- <el-input v-model="item.agentprice" @blur="NumberF(item)"></el-input> -->
                  </div>
                </div>
                <div v-if="item.status=='2'">
                  停售
                </div>
                <div v-if="item.status=='3'">
                  暂无授权数量
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="dateWeek.sunday" width="180">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.cld_list" :key="index" v-show="item.date==dateWeek.sunday.substring(0,10)">
                <div v-if="item.status=='1'">
                  <div class="disFlex"> 数量：<el-input
                      :value="formatDaynumber(item)"
                      @input="onDaynumberInput($event, item)"
                      @blur="NumberF(item, scope.row.impowerState)"
                      :readonly="scope.row.impowerState != 1"></el-input>
                  </div>
                  <div class="disFlex agent"> 代理价：
                    <input type="number" v-model="item.agentprice" @blur="NumberP(item)">
                    <!-- <el-input v-model="item.agentprice" @blur="NumberF(item)"></el-input> -->
                  </div>
                </div>
                <div v-if="item.status=='2'">
                  停售
                </div>
                <div v-if="item.status=='3'">
                  暂无授权数量
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column >
            <template slot="header">
              <span>日库存<span style="color: red;">（默认不限制）</span></span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.DayNumber" @blur="NumberDay(scope.row)"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="address" label="操作" >
            <template slot-scope="scope">
                <div class="plsetfnClss">
                  <el-button type="text" @click="plSetFn(scope.row)">批量设置</el-button>
                </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" 
            :page-size="data.page_size" :current-page="data.page" @current-change="curren"></el-pagination>
      </div>
      <div class="itemBtnS">
        <el-button class="btnL" :loading="submitLoading" @click="clearsBnt">取消授权</el-button>
        <el-button class="btnL" :loading="submitLoading" @click="calendarBnt">确认授权</el-button>
      </div>
    </el-dialog>
    <!-- 日历票授权弹框结束 -->
    <!-- 批量设置弹框开始 -->

    <el-dialog
      title="日历批量授权"
      :visible.sync="plSetDialogVisible"
      :before-close="plSetHandleClose"
      width="36.1%"
      center
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="100px" :model="form">
        <div class="flexDis itemInp">
          <el-form-item label="日期:">
            <!-- <span class="absPosiA">*</span> -->
            <el-date-picker
              v-model="form.value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="星期:">
          <!-- <span class="absPosiB">*</span> -->
          <div class="disX">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            >每日</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="结算价:">
          <!-- <span class="absPosiB">*</span> -->
          <el-input v-model="form.name" placeholder="请输入结算价"></el-input>
          <span class="dw">元</span>
        </el-form-item>
        <el-form-item class="itemBtnS">
          <el-button>清空</el-button>
          <el-button class="btnL" @click="BatchProduct">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 批量设置弹框结束 -->
  </div>
</template>

<script>
import { Message } from "element-ui";
import {getDistributorCldList,GetWeek,
  aloneCldProduct,batchCldProduct,
  ScenicAuthorizationDis,NewScenicAuthorizationDis,ScenicCancelDisImpower,SetDayAstrict} from '@/request/scenic.js'
const cityOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
export default {
  props:['caldarId'],
  data() {
    return {
      batchProductID:'',
      cldkey:'',
      loading:true,
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
      defailDialogVisible: false, // 详情弹框
      plSetDialogVisible: false, // 日历批量授权
      dateWeek: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        staturday: "",
        sunday: ""
      },
      tableData: [
       
      ],
      multipleSelection: [],

      options: [
      ],
      form: {
        name: "",
        oldName: "",
        value1: "",
      },
      value: "",
      value2: "",
      value3: "",
      radio: 1,
      editTitle: "", // 弹框标题
      btnType: "", // 详情和确认按钮区别
      data:{
        token:window.sessionStorage.getItem('Token'),
        startTime:'',
        endTime:'',
        page:1,
        page_size:5,
        name:''
      },
      total:0,
      yesid:'',
      noid:'',
      idtotal:0,
      dataId:'',
      dayNumberStr: '',
      NumberDayList:[],
      submitLoading: false // 确认授权/取消授权按钮 loading
    };
  },
  mounted() {
    this.getMondayAndSunday();
    this.getList()
  },
  methods: {
    curren(e){
      this.data.page = e
      this.loading = true
      this.getList()
    },
    NumberDay(item){
      if(item.dayNumb==item.DayNumber){
        Message.error('数量未修改')
        return false
      }
      if(item.impowerState == 2){
        let arr = this.yesid.split(',').map(item => item.trim()).filter(item => item !== '');
        let index = arr.findIndex((it)=>{
          return it == item.ProductID
        })
        if (index != -1) {
          let str = this.dayNumberStr.split(',').map(item => item.trim()).filter(item => item !== '');
          str = [...Array(Math.max(str.length, index + 1))].map((_, i) => 
            i < str.length && str[i] !== undefined ? str[i] : (i === index ? item.DayNumber : 9999)
          );
          str[index] = item.DayNumber
          this.dayNumberStr = str
          this.dayNumberStr = this.dayNumberStr.join(',') + ','
        }
        return
      }
      
      // if(item.DayNumber>item.dayNumb&&item.dayNumb!=0){
      //   Message.error(`授权数量不能大于库存数量 日库存：${item.dayNumb}`)
      //   return false
      // }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ProductID:item.ProductID,
        DistributorID:this.caldarId,
        DayNum:item.DayNumber==''?'0':item.DayNumber,
        AllNumber:item.NumBerflag==''?'0':item.NumBerflag
      }
      SetDayAstrict(data).then(res=>{
          if(res.data.status=='ok'){
            Message.success('设置成功')
            this.getList()
          }else{
            Message.error(res.data.msg)
          }
      })
      // item.cld_list.map(im=>{
      //   im.daynumber =  item.DayNumber 
      // })
    },
    // 取消授权：只取消「已授权且当前被取消勾选」的产品（取消勾选后又勾选回去的不会算在内）
    clearsBnt(){
      const selectedIds = new Set((this.multipleSelection || []).map(row => row && row.ProductID).filter(Boolean))
      // 已授权(impowerState==1) 且 当前未勾选 的，才是待取消授权的
      const toCancelList = (this.tableData || []).filter(
        row => row.impowerState == '1' && row.ProductID && !selectedIds.has(row.ProductID)
      ).map(row => row.ProductID)
      if (toCancelList.length === 0) {
        Message.error('请先取消勾选要取消授权的产品')
        return false
      }
      const id = [...new Set(toCancelList)].join(',')
      let data = {
        token:window.sessionStorage.getItem('Token'),
        DistributorID:this.caldarId,
        ProductID:id
      }
      this.submitLoading = true
      ScenicCancelDisImpower(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('取消授权成功')
          this.yesid = ''
          this.noid = ''
          this.idtotal = 0
          this.dataId = ''
          return this.getList()
        }else{
          Message.error(res.data.msg)
        }
      }).finally(()=>{
        this.submitLoading = false
      })
    },
    // 确认授权产品
    calendarBnt(){
      if(this.yesid==''){
        Message.error('请选择授权产品')
        return false
      }
      let dataID = ''
      let id = ''
      if(this.dataId!=''){
        dataID = this.dataId
      }
      [...new Set(this.yesid.split(','))].map(item=>{
        if(item){
          id += item + ','
        }
      })
      if (id.length > 0) {
        id  = id.substr(0,id.length - 1);
      }
      if (this.dayNumberStr.endsWith(',')) {
        this.dayNumberStr = this.dayNumberStr.slice(0, -1);
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutorid:this.caldarId,
        ProductID:id,
        DayNumber: this.dayNumberStr
      }
      this.submitLoading = true
      NewScenicAuthorizationDis(data).then(res=>{
          if(res.data.status=='ok'){
            Message.success('授权成功')
            this.yesid = ''
            this.noid = ''
            this.idtotal = 0
            this.dataId = ''
            this.dayNumberStr = ''
            return this.getList()
          }else{
            Message.error(res.data.msg)
          }
      }).finally(()=>{
        this.submitLoading = false
      })
    },
    // 批量设置
    BatchProduct(){
      var start = ''
      var end = ''
      if(!this.form.value1){
        Message({
          type: "error",
          message: "请选择日期"
        })
        return false
      }else{
        start = this.form.value1[0]
        end = this.form.value1[1]
      }
      var arr = ''
      if(this.checkedCities.length!=0){
        this.checkedCities.map(item=>{
          switch(item){
            case '星期一':
             arr+='1'+','
                break;
            case '星期二':
            arr+='2'+','
                break;
            case '星期三':
            arr+='3'+','
                break;
            case '星期四':
            arr+='4'+','
                break;
            case '星期五':
            arr+='5'+','
                break;
            case '星期六':
            arr+='6'+','
                break;
            case '星期日':
            arr+='7'+','
                break;
            default:
                break;
          }
        })
      }else{
        Message({
              type: "error",
              message: "请选择星期"
        })
        return false
      }
      if(this.form.name == this.form.oldName){
        Message({
          type: "error",
          message: "结算价未修改"
        })
        return false
      }
      if (arr.length > 0) {
        arr = arr.substr(0,arr.length - 1);
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutorid:this.caldarId,
        ProductID:this.batchProductID,
        start_date:start,
        end_date:end,
        week:arr,
        agentprice:this.form.name
      }
      batchCldProduct(data).then(res=>{
        if(res.data.result==true){
          this.getMondayAndSunday();
          this.getList()
          Message({
            type: "success",
            message: "批量设置成功"
          })
          this.plSetDialogVisible = false;
        }else{
          Message({
            type: "error",
            message: res.data.msg
          })
          this.checkedCities = []
          this.plSetDialogVisible = false;
        }
      })
    },
    isUnlimited(val){
      return Number(val) == -9
    },
    formatDaynumber(item){
      const val = item.daynumber
      if(val == ''){
        return ''
      }
      if(val == '-'){
        return '-'
      }
      // 输入过程中的字符串（如 "0" "0." "132.0" "132.05"）是用户输入的可用数量，原样显示
      if(typeof val === 'string' && /^\d*\.?\d*$/.test(val)){
        return val
      }
      // 只有 -9 显示为"无限制"，-1 就显示 -1
      if(Number(val) == -9){
        return '无限制'
      }
      // -1 直接显示 -1
      if(Number(val) == -1){
        return '-1'
      }
      const actualSalesVolume = item.Actual_sales_volume || 0
      const numVal = Number(val)
      // 如果 val 不是有效数字，返回空字符串
      if(isNaN(numVal)){
        return ''
      }
      const result = numVal - Number(actualSalesVolume)
      return result >= 0 ? result : ''
    },
    onDaynumberInput(val,item){
      if(val === '无限制'){
        item.daynumber = -1
        return
      }
      // 允许输入 - 字符（用于输入 -1），暂时不更新 daynumber
      if(val == '-'){
        item.daynumber = '-'
        return
      }
      if(val == ''){
        item.daynumber = ''
        return
      }
      // 判断是否是 -1（无限制）
      if(val == '-1'){
        item.daynumber = -1
        return
      }
      // 输入过程中的数字（含 "0" "0." "132.0" "132.05"）保存，支持小数输入
      if(/^\d*\.?\d*$/.test(val)){
        if(val === '.'){
          item.daynumber = '0.'
          return
        }
        if(val.endsWith('.')){
          item.daynumber = val
          return
        }
        const num = parseFloat(val)
        if(isNaN(num)){
          item.daynumber = ''
          return
        }
        // 负数（除 -1）不允许
        if(num < 0) return
        // 用户输入的是可用数量，直接保存字符串以保留 "0" "132.0" 等
        item.daynumber = val
      }
    },
    // 日历单独设置
    NumberF(item, impowerState){
      if(impowerState != 1) return
      
      // 如果 daynumber 是字符串（如 '-' 或 '' 或 '0.'），说明用户正在输入，不执行验证
      if(typeof item.daynumber === 'string' && (item.daynumber === '-' || item.daynumber === '' || item.daynumber.endsWith('.'))){
        return
      }
      
      const actualSalesVolume = Number(item.Actual_sales_volume || 0)
      // daynumber 为字符串时表示用户输入的可用数量，需转为授权数量（可用数量 + 实际销量）
      const enteredAvailable = typeof item.daynumber === 'string' ? parseFloat(item.daynumber) : (Number(item.daynumber) - actualSalesVolume)
      const stockForApi = typeof item.daynumber === 'string' ? (enteredAvailable + actualSalesVolume) : item.daynumber

      // 如果设置为无限制(-9 是接口返回的，-1 是用户输入的)，不需要验证库存限制
      if(item.daynumber != -9 && item.daynumber != -1 && item.product_stock != -9){
        const availableStock = Number(item.product_stock) - actualSalesVolume
        if(enteredAvailable > availableStock){
          Message.error(`授权数量不能大于可用库存数量 可用库存：${availableStock >= 0 ? availableStock : 0}`)
          this.getList()
          return false
        }
      }
      // 判断是否是无限制：-9 是接口返回的，-1 是用户输入的
      const isCurrentUnlimited = item.daynumber === -9 || item.daynumber === -1
      const isPrevUnlimited = item.day3 === -9 || item.day3 === -1
      // 如果都是无限制，认为未修改
      if(isCurrentUnlimited && isPrevUnlimited){
        Message.error('数量未修改')
        return false
      }
      // 如果都不是无限制且值相同，认为未修改
      const prevAvailable = typeof item.day3 === 'number' ? (item.day3 - actualSalesVolume) : item.day3
      if(!isCurrentUnlimited && !isPrevUnlimited && prevAvailable == enteredAvailable){
        Message.error('数量未修改')
        return false
      }
      if(!isCurrentUnlimited && this.day1 == stockForApi){
        Message.error('数量未修改')
        return false
      }
      // 验证：大于 0 或者是无限制(-9 或 -1) 就通过
      if(!isCurrentUnlimited && (isNaN(enteredAvailable) || enteredAvailable <= 0)){
        Message.error('数量必须大于0或设置为无限制(-1)，可以设置禁售！')
        this.getList()
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutorid:this.caldarId,
        ProductID:item.productid,
        day:item.date,
        stock:item.daynumber === -1 ? 0 : (item.daynumber === -9 ? 0 : (item.daynumber === 0 ? 0 : stockForApi)),
        agentprice:item.agentprice
      }
      aloneCldProduct(data).then(res=>{
        if(res.data.rcode==200){
          // this.cldkey = res.data.result
          Message({
              type: "success",
              message: "日历设置成功"
          })
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    NumberP(item){
      if(item.day4==item.agentprice){
        Message.error('价格未修改')
        return false
      }
      if(this.day2==item.agentprice){
        Message.error('价格未修改')
        return false
      }
       if(item.agentprice<=0){
        Message.error('价格不能小于0')
        this.getList()
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutorid:this.caldarId,
        ProductID:item.productid,
        day:item.date,
        stock:item.daynumber,
        agentprice:item.agentprice
      }
      aloneCldProduct(data).then(res=>{
        if(res.data.rcode==200){
          // this.cldkey = res.data.result
          Message({
              type: "success",
              message: "日历设置成功"
          })
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    fun_date(num, data) {
      this.loading =true
      let date1 = new Date(data.slice(0,data.length-1));
      //今天时间
      let time1 =
        date1.getFullYear() +
        "-" +
        (date1.getMonth() + 1) +
        "-" +
        date1.getDate();
      let date2 = new Date(date1);
      date2.setDate(date1.getDate() + num);
      //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
      let time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate();
      this.getMondayAndSunday(time2)
      this.getList()
    },
    listBtns(){
      this.data.page = 1
      this.total = 0
      this.getList()
    },
    getList(){
      this.loading = true
      this.data.distributorid=this.caldarId
      this.data.startTime=this.dateWeek.monday.substring(0,10)
      this.data.endTime=this.dateWeek.sunday.substring(0, 10)
      return getDistributorCldList(this.data).then(res=>{
        if(res.data.rcode ==200){
          this.dataId = res.data.result.ProductID
          this.tableData = res.data.result.data.data
          this.total = res.data.result.data.total
          this.tableData.forEach(item=>{
            item.ProductName = '[' + item.ProductID + ']   ' + item.ProductName
            item.dayNumb=item.DayNumber
            item.cld_list.forEach(itm=>{
              itm.day3 = itm.daynumber
              itm.day4 = itm.agentprice
            })
          })
          // 等表格用新数据渲染后再统一恢复勾选，避免先清空 multipleSelection 导致再次点击取消授权时误判
          this.$nextTick(()=>{
            if(this.$refs.multipleTable){
              this.$refs.multipleTable.clearSelection()
              this.tableData.forEach(item=>{
                if(item.impowerState=='1'){
                  this.$refs.multipleTable.toggleRowSelection(item, true)
                }
              })
            }
          })
        }
      }).finally(()=>{
        this.loading = false
      })
    },  
    // 周全选
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    // 点击批量设置
    plSetFn(row) {
      if(row.impowerState=='2'){
        Message.error('未授权产品禁止批量修改')
        return false
      }
      this.plSetDialogVisible = true;
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ProductId:row.ProductID,
        DistributorID:this.caldarId
      }
      this.batchProductID = row.ProductID
      GetWeek(data).then(res=>{
        if(res.data.rcode){
          this.form.value1 = [res.data.result.start_date,res.data.result.end_date]
          this.form.name = res.data.result.agentprice
          this.form.oldName = res.data.result.agentprice
          if(res.data.result.week!=''){
            res.data.result.week.split(',').map(item=>{
              switch (item) {
                    case '7':
                        this.checkedCities.push('星期日')
                        break;
                    case '6':
                        this.checkedCities.push('星期六')
                        break;
                    case '5':
                        this.checkedCities.push('星期五')
                        break;
                    case '4':
                        this.checkedCities.push('星期四')
                        break;
                    case '3':
                        this.checkedCities.push('星期三')
                        break;
                    case '2':
                        this.checkedCities.push('星期二')
                        break;
                    case '1':
                        this.checkedCities.push('星期一')
                        break;
                   default:
              }
            })
          }
         
        }
      })
      // this.defailDialogVisible = false;
    },
    // 点击批量设置X
    plSetHandleClose() {
      this.plSetDialogVisible = false;
    },
    // 日历票授权
    caldarTct(row) {
      if (row) {
        this.editTitle = "分销商详情";
      } else {
        this.editTitle = "添加分销商";
      }
      this.btnType = 2;
      this.defailDialogVisible = true;
    },
    // 日历票授权X
    defailHandleClose() {
      this.$emit('defailClose')
      this.defailDialogVisible = false;
    },
    // 表格全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      // 记录当前选中数量
      this.idtotal = val.length

      // 新增选中时，追加 yesid 和 dayNumberStr
      if (val.length > 0) {
        const last = val[val.length - 1]
        if (last && last.impowerState == '2') {
          this.yesid += last.ProductID + ','
          if (!last.DayNumber) {
            this.dayNumberStr += '0,'
          } else if (last.DayNumber > 0) {
            this.dayNumberStr += String(last.DayNumber) + ','
          }
        }
      }

      // 处理取消选中的记录
      if (this.multipleSelection && this.multipleSelection.length) {
        const removed = this.multipleSelection.filter(
          prev => !val.find(v => v && v.ProductID === prev.ProductID)
        )
        removed.forEach(r => {
          if (r && r.ProductID) {
            this.noid += r.ProductID + ','
          }
        })
      }

      this.multipleSelection = val
    },
    //获取周一到周天的日期
    getMondayAndSunday(data) {
      if(data){
        var now = new Date(data);
      }else{
        var now = new Date(); //获取当前时间（也可以直接用某一天） 计算当前周一和周日
      }
      var nowTime = now.getTime();
      var day = now.getDay();
      var oneDayLong = 24 * 60 * 60 * 1000;

      var MondayTime = nowTime - (day - 1) * oneDayLong;
      var tuesdayTime = nowTime - (day - 2) * oneDayLong;
      var wednesdayTime = nowTime - (day - 3) * oneDayLong;
      var thursdayTime = nowTime - (day - 4) * oneDayLong;
      var fridayTime = nowTime - (day - 5) * oneDayLong;
      var staturdayTime = nowTime - (day - 6) * oneDayLong;
      var sundayTime = nowTime - (day - 7) * oneDayLong;

      if (now.getDay() == 0) {
        //因为周日是比较特殊的，需特别处理
        MondayTime = nowTime - 6 * oneDayLong;
        var tuesdayTime = nowTime - 5 * oneDayLong;
        var wednesdayTime = nowTime - 4 * oneDayLong;
        var thursdayTime = nowTime - 3 * oneDayLong;
        var fridayTime = nowTime - 2 * oneDayLong;
        var staturdayTime = nowTime - 1 * oneDayLong;
        var sundayTime = nowTime - 0 * oneDayLong;
      }
      var monday = new Date(MondayTime);
      var tuesday = new Date(tuesdayTime);
      var wednesday = new Date(wednesdayTime);
      var thursday = new Date(thursdayTime);
      var friday = new Date(fridayTime);
      var staturday = new Date(staturdayTime);
      var sunday = new Date(sundayTime);
      var monday0 = ''
      if((monday.getMonth() + 1)<10){
        monday0 = '0' + (monday.getMonth() + 1)
      }else{
        monday0 =  (monday.getMonth() + 1)
      }
      let monMon = ''
      if(monday.getDate()<10){
        monMon = '0' +monday.getDate()
      }else{
        monMon =  monday.getDate()
      }
      monday =monday.getFullYear() +"-" + monday0 +"-" +monMon;


      var tuseday0 = ''
      if((tuesday.getMonth() + 1)<10){
        tuseday0 = '0' + (tuesday.getMonth() + 1)
      }else{
        tuseday0 =  (tuesday.getMonth() + 1)
      }
      let tuesMon = ''
      if(tuesday.getDate()<10){
        tuesMon = '0' + tuesday.getDate()
      }else{
        tuesMon =  tuesday.getDate()
      }
      tuesday =
        tuesday.getFullYear() +
        "-" +
        tuseday0 +
        "-" +
        tuesMon;


      var wednesday0 = ''
      if( (wednesday.getMonth() + 1)<10){
        wednesday0 = '0' +  (wednesday.getMonth() + 1)
      }else{
        wednesday0 =   (wednesday.getMonth() + 1)
      }
      let wednesMon = ''
      if(wednesday.getDate()<10){
        wednesMon = '0' + wednesday.getDate()
      }else{
        wednesMon =  wednesday.getDate()
      }
      wednesday =
        wednesday.getFullYear() +
        "-" +
        wednesday0 +
        "-" +
        wednesMon;



      var thursday0 = ''
      if((thursday.getMonth() + 1)<10){
        thursday0 = '0' +  (thursday.getMonth() + 1)
      }else{
        thursday0 =   (thursday.getMonth() + 1)
      }
      let thursMon = ''
      if(thursday.getDate()<10){
        thursMon = '0' + thursday.getDate()
      }else{
        thursMon =  thursday.getDate()
      }
      thursday =
        thursday.getFullYear() +
        "-" +
        thursday0 +
        "-" +
        thursMon;


      var friday0 = ''
      if((friday.getMonth() + 1)<10){
        friday0 = '0' + (friday.getMonth() + 1)
      }else{
        friday0 =  (friday.getMonth() + 1)
      }
      let fridayMon = ''
      if(friday.getDate()<10){
        fridayMon = '0' + friday.getDate()
      }else{
        fridayMon =  friday.getDate()
      }
      friday =
        friday.getFullYear() +
        "-" +
        friday0 +
        "-" +
        fridayMon;


      var staturday0 = ''
      if((staturday.getMonth() + 1)<10){
        staturday0 = '0' + (staturday.getMonth() + 1)
      }else{
        staturday0 = (staturday.getMonth() + 1)
      }
      let staturdayMon = ''
      if(staturday.getDate()<10){
        staturdayMon = '0' + staturday.getDate()
      }else{
        staturdayMon =  staturday.getDate()
      }
      staturday =
        staturday.getFullYear() +
        "-" +
        staturday0 +
        "-" +
        staturdayMon;


        var sunday0 = ''
        if((sunday.getMonth() + 1)<10){
          sunday0 = '0' + (sunday.getMonth() + 1)
        }else{
          sunday0 =(sunday.getMonth() + 1)
        }
        let sundayMon = ''
        if(sunday.getDate()<10){
          sundayMon = '0' + sunday.getDate()
        }else{
          sundayMon =  sunday.getDate()
        }
        sunday =
          sunday.getFullYear() +
          "-" +
          sunday0 +
          "-" +
          sundayMon;
       
      this.dateWeek.monday = monday + "\n" + "一";
      this.dateWeek.tuesday = tuesday + "\n" + "二";
      this.dateWeek.wednesday = wednesday + "\n" + "三";
      this.dateWeek.thursday = thursday + "\n" + "四";
      this.dateWeek.friday = friday + "\n" + "五";
      this.dateWeek.staturday = staturday + "\n" + "六";
      this.dateWeek.sunday = sunday + "\n" + "七";
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
 /deep/.el-table td,/deep/.el-table_2_column_8{
  text-align:left !important;
}
.editForm {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .el-input {
    width: 500px;
  }
  .dw {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    margin: 10px;
  }
}
.disX {
  width: 502px;
  height: 80px;
  display: flex;
  // background: red;
  .el-checkbox {
    margin-right: 20px;
  }
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
.athorTitle {
  margin-bottom: 20px;
  .el-button {
    width: 110px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
  .el-date-editor {
    width: 180px;
    margin: 0 20px;
  }
}
.itemBtnS {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
  margin-left: -100px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.authorTable {
  .el-input {
    width: 100px;
    height: 30px;
  }
  /deep/.el-input__inner {
    -webkit-appearance: none;
    background: #f7f7fa;
    border-radius: 4px;
    border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 30px;
    line-height: 30px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    text-align: center;
  }
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 20px auto 0px;
  }
  /deep/.el-table .cell {
    white-space: pre-line;
  }
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/.el-table td,.el-table th {
    padding: 5px 0;
  }
  .disFlex{
    display: flex;
    margin: 1rem 0;
  }
  .disFlex /deep/ .el-input{
    width: 80px !important;
  }
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 20px auto 0px;
  }
  
/deep/ .el-table__row,/deep/.el-table__row td{
  height: 9rem !important;
}
.agent {
  color: #FFB741;
  font-size: 1.4rem;
}
.agent  input{
  padding-left: 0.3rem;
  border: none;
  background: #fff;
  color: #FFB741;
  width: 6rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.title_flex{
  display: flex;
  justify-content: space-between;
}
.input_btns{
  display: flex;
  align-items: center;
  /deep/.el-button{
    margin-left: 2rem;
    width: 110px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
}
/deep/.has-gutter .el-checkbox{
  display: none;
}
.plsetfnClss{
  width: 100%;
  text-align: center;
}
::v-deep .cell{
  text-align: center !important;
}
</style>